import { useMutation } from '@tanstack/react-query';
import { AuthError } from '@supabase/supabase-js';

import { supabaseClient } from 'src/auth/supabase';
import { PathNames } from 'src/shared/enum/PathNames';

export const useResetPasswordSupabase = () =>
    useMutation<void, AuthError, { email: string }>({
        mutationFn: async ({ email }) => {
            const { error } = await supabaseClient.auth.resetPasswordForEmail(email, {
                redirectTo: `${window.location.origin}${PathNames.RESET_PASSWORD}`,
            });

            if (error) throw error;
        },
    });
